import React, { FC, useState } from "react";
import { useHistory } from "react-router-dom";
import clsx from "clsx";

import { careerPath } from "../../../store/student";
import { APPLY_FOR_CAREER_MAP_GENERATION_MESSAGE } from "../../../constants/career";
import ModalConfirm from "../../../molecules/ModalConfirm";

import styles from "./FormActions.module.scss";

type Props = {
  isQuestionsCompletedForTermNo1: boolean;
  saveCareerSheetAnswers: () => void;
  applyForCareerMapGeneration: () => void;
};

const FormActions: FC<Props> = ({
  isQuestionsCompletedForTermNo1,
  saveCareerSheetAnswers,
  applyForCareerMapGeneration,
}) => {
  const history = useHistory();
  const [isShowModalConfirm, setIsShowModalConfirm] = useState(false);

  return (
    <>
      <div className={styles.wrapper}>
        <button
          className={clsx(styles.button, styles.save)}
          onClick={() => saveCareerSheetAnswers()}
        >
          下書き保存
        </button>
        <button
          className={clsx(styles.button, styles.apply)}
          onClick={() => setIsShowModalConfirm(true)}
          disabled={!isQuestionsCompletedForTermNo1}
        >
          キャリア開拓MAPをつくる
        </button>
      </div>
      <ModalConfirm
        isOpen={isShowModalConfirm}
        message={
          <div className={styles.message}>
            <p className={styles.title}>
              {APPLY_FOR_CAREER_MAP_GENERATION_MESSAGE.title}
            </p>
            <br />
            <p className={styles.text}>
              {APPLY_FOR_CAREER_MAP_GENERATION_MESSAGE.text}
            </p>
          </div>
        }
        buttons={[
          {
            title: "キャンセル",
            type: "None",
            action: () => {
              setIsShowModalConfirm(false);
            },
          },
          {
            title: "申請する",
            type: "Success",
            action: () => {
              saveCareerSheetAnswers();
              applyForCareerMapGeneration();
              setIsShowModalConfirm(false);
              history.push(careerPath);
            },
          },
        ]}
      />
    </>
  );
};

export default FormActions;
